<script setup lang="ts">
defineProps<{
  itemsLength: number;
  activeItemIndex: number;
  border?: boolean;
}>();

const emit = defineEmits<{
  (e: "index-change", index: number): void;
}>();
</script>

<template>
  <div class="flex flex-row gap-2">
    <button
      class="bg-platform-bg-1 rounded-full p-3"
      :disabled="activeItemIndex === 0"
      :class="[
        activeItemIndex === 0 && 'opacity-50',
        border && 'border border-platform-border-1',
      ]"
      data-test="navigation-button-previous"
      @click="emit('index-change', activeItemIndex - 1)"
    >
      <BaseIcon
        name="chevronLeft"
        :size="20"
      />
    </button>
    <button
      class="bg-platform-bg-1 rounded-full p-3"
      :disabled="activeItemIndex === itemsLength - 1"
      :class="[
        activeItemIndex === itemsLength - 1 && 'opacity-50',
        border && 'border border-platform-border-1',
      ]"
      data-test="navigation-button-next"
      @click="emit('index-change', activeItemIndex + 1)"
    >
      <BaseIcon
        name="chevronRight"
        :size="20"
      />
    </button>
  </div>
</template>
